import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { NoiseOverlay } from "@/components/layout/NoiseOverlay";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

import Home from "@/pages/Home";
import Societies from "@/pages/Societies";
import Commercial from "@/pages/Commercial";
import Advertisers from "@/pages/Advertisers";
import Platform from "@/pages/Platform";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <NoiseOverlay />
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/societies" element={<Societies />} />
              <Route path="/commercial" element={<Commercial />} />
              <Route path="/advertisers" element={<Advertisers />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/insights/:slug" element={<Article />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="/terms-advertisers" element={<Legal kind="terms-advertisers" />} />
              <Route path="/terms-societies" element={<Legal kind="terms-societies" />} />
              <Route path="/terms" element={<Legal kind="terms-advertisers" />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
